import React from "react";

export function PCLink() {


  return (
    <div
      onClick={() => {
        window.open(
          'https://forms.office.com/e/HnYfZ56u2j?origin=lprLink',
          '_blank'
        );
      }}
      style={{
        right: '0',
        float:'right',
        color: 'white',
        border: 'none',
        fontSize: '15px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
        cursor: 'pointer',
        transition: 'opacity 0.3s',
        zIndex: -9999,
        padding: '10px 15px',
        position:'absolute',
        marginBottom:'65px'
       
      }}
    >
      Product Catalog Support
    </div>
  );
}